<template>
  <div>
    <el-row v-if="isProgress(day.load_date)">
      <el-col :span="22" class="progress-block">
        <el-row class="prices">
          <el-col class="tt-cap dark w90">
            {{ day.load_date | getHumanDate }},
          </el-col>
          <el-col class="w-auto">
            <template v-if="type !== 'harvest'">
              <span v-if="type === 'harvest_or_delivery'">Перевозка:</span>
              <span v-if="!isDispatcherRole">
                цена заказчика
                <b class="progress-block__not-subs">
                  {{ day.price_from_storage_bidder | getPrice }}
                </b>
              </span>
              <span v-if="isAdminOrCeoRole || isDispatcherRole">
                цена водителя
                <b
                  :class="[
                    'progress-block__subs',
                    { redColor: !day.price_from_storage_driver },
                  ]"
                >
                  {{ day.price_from_storage_driver | getPrice }}
                </b>
              </span>
            </template>
            <template v-if="type !== 'delivery'">
              <br v-if="type === 'harvest_or_delivery'" />
              <span v-if="type === 'harvest_or_delivery'" class="harvest">
                Уборка:
              </span>
              <span>
                цена заказчика
                <b class="progress-block__not-subs">
                  {{ day.price_from_field_bidder | getPrice }}
                </b>
              </span>
              <span v-if="isAdminOrCeoRole">
                цена водителя
                <b
                  :class="[
                    'progress-block__subs',
                    { redColor: !day.price_from_field_driver },
                  ]"
                >
                  {{ day.price_from_field_driver | getPrice }}
                </b>
              </span>
            </template>
            <span v-if="day.status === 1" class="day-status">
              (День закрыт)
            </span>
            <span v-if="day.total_report_created_at" class="day-report">
              (Отчет сдан)
            </span>
          </el-col>
        </el-row>
        <div class="progress-block__bar">
          <div class="progress-block__progresses">
            <zerno-progress-bar :percentages="getPercentages(day)" />
          </div>

          <span class="progress-block__text">
            <span :class="{ success: day.responses_count_approved > 0 }">
              ({{ day.responses_count_approved }} / {{ day.cars_count }})
            </span>
          </span>
          <span v-if="!isDispatcherRole">
            <el-button
              :type="isRegistrySentToday ? 'success' : 'danger'"
              plain
              :class="
                isRegistrySentToday ? 'sentSuccessClass' : 'sentErrorClass'
              "
              icon="el-icon-message"
              size="small"
              @click="visibleLogDialog = true"
            />
          </span>
        </div>
      </el-col>
    </el-row>
    <RegistrySentToday
      :id="day['id']"
      :visible="visibleLogDialog"
      @close="visibleLogDialog = false"
    />
  </div>
</template>

<script>
import { isFutures } from '@/helpers/functions'
import RegistrySentToday from '@/components/Shared/RegistrySentToday'
import ZernoProgressBar from '@/components/Shared/ZernoProgressBar'

export default {
  name: 'ShortDayInfo',
  components: { ZernoProgressBar, RegistrySentToday },
  props: {
    day: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visibleLogDialog: false,
    }
  },
  computed: {
    isRegistrySentToday() {
      return this.day['registry_sent_today']
    },
  },
  methods: {
    isProgress(date) {
      return isFutures(date) && this.canAction('shipping_bids_edit')
    },
    getPercentages(day) {
      const {
        cars_count: dayCarsCount,
        responses_count_not_served: notServedCount,
        responses_count_approved: approvedCount,
        response_requests_count: requestCount,
      } = day

      return { dayCarsCount, notServedCount, approvedCount, requestCount }
    },
  },
}
</script>

<style lang="sass">
.el-tooltip__popper.is-light
  padding: 5px 10px
  color: #303133
  font-family: 'Mulish', sans-serif!important
  border: none!important
  box-shadow: 0 0 1rem rgba(132, 132, 132, 0.15)
.popper__arrow
  border: none!important
  box-shadow: 0 0 1rem rgba(132, 132, 132, 0.15)

.progress-block
  margin-top: 20px
  span
    margin-right: 5px
  .sentSuccessClass
    padding: 3px 7px
    margin-left: 4px
    font-weight: bold
    color: #00bf40
    font-size: 18px
  .sentErrorClass
    padding: 3px 7px
    margin-left: 4px
    font-weight: bold
    color: #ff0000
    font-size: 18px
  .prices
    margin: 0 0 7px
    font-size: 14px
    color: rgba(0, 0, 0, 0.47)
    .w90
      width: 90px
  .dark
    color: #393939

  &__bar
    display: flex
    align-items: center
    span.success
      color: #67c23a
  &__subs
    color: #589839
  &__not-subs
    color: #3498db
  &__progresses
    flex: 0 0 60%
    max-width: 60%
    position: relative
  &__text
    margin-left: 5px
    font-size: 14px
    color: #000
  .day-status
    margin-left: 5px
    font-size: 14px
    color: #f10000
  .day-report
    margin-left: 5px
    font-size: 14px
    color: #67c23a
</style>
